import { useEffect, useState } from 'react';
import { FAILED, PENDING, PROCESSING, SUCCESSFUL } from '../../lib/shared/payment-statuses';

const REPEAT_REQUEST_TIMEOUT = 2000;

function useStatusPurchase({id, getStatus}) {
    const [purchaseData, setPurchaseData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const getData = async (isInitial = false) => {
        const data = await getStatus(id);

        setPurchaseData(data);

        if (isInitial) {
            setIsLoading(false);
        }

        return data;
    };

    useEffect(() => {
        getData(true);
    }, []);

    useEffect(() => {
        let intervalId = null;

        if (purchaseData.paymentStatus === PROCESSING || purchaseData.paymentStatus === PENDING) {
            intervalId = setInterval(async () => {
                const data = await getData();

                if (data.paymentStatus === FAILED || data.paymentStatus === SUCCESSFUL) {
                    clearInterval(intervalId);

                    intervalId = null;
                };
            }, REPEAT_REQUEST_TIMEOUT);
        };

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        }
    }, [purchaseData.paymentStatus]);

    return {
        purchaseData,
        isLoading
    };
};

export {
    useStatusPurchase
};
